import React, { useMemo } from 'react';
import { selectIsLoading } from 'features/location/selectors';
import { useTypedSelector } from 'lib/centralStore';

export const useIsNavigating = (): boolean => {
  const isLoadingFactory = useMemo(() => selectIsLoading, []);
  return useTypedSelector((state) => isLoadingFactory(state));
};